import HeatmapChart from './MCTCharts/6heatmapChart/6HeatmapChart';
import TotalEatenBaitLineChart from './SBSCharts/1TotalEatenBaitLineChart/1totalEatenBaitLineChart';

import { TrapType } from 'components/AnalyticsPage/TrapType';

interface PageProps {
  slug: string;
  trapType: TrapType;
}

const SBSPage: React.FC<PageProps> = ({ slug, trapType }) => {
  return (
    <>
      <div className="row">
        <div className="col-xxl-12 my-2">
          <HeatmapChart slug={slug} type={trapType} />
        </div>

        <div className="col-md-12 my-2">
          <TotalEatenBaitLineChart slug={slug} />
        </div>
      </div>
    </>
  );
};

export default SBSPage;
